import { useState, createContext, useEffect, useCallback } from 'react';
import MyFunctions from '../Functions/MyFunctions';

export const SpecialUserContext = createContext();

export const SpecialUserContextProvider = props => {
    const [specialUser, setSpecialUser] = useState();

    useEffect(() => {
        let usrOn = JSON.parse(sessionStorage.getItem("SpecU"))
        if (usrOn) {
            setSpecialUser(usrOn)
        }
    }, []);

    useEffect(() => {
        let tempUsr = { ...specialUser }
        sessionStorage.setItem("SpecU", JSON.stringify(tempUsr));
    }, [specialUser]);

    return (
        <SpecialUserContext.Provider value={[specialUser, setSpecialUser]}>
            {props.children}
        </SpecialUserContext.Provider>
    );
};